module.exports = __webpack_public_path__ + "img/instagram-text.ea90b1bf.svg";